import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersNotDispatched(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.notDispatched}
      subtitle={texts.notDispatchedTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.notDispatched}
        value={count}
        disabled={count === 0}
        testId="plan-summary-not-dispatched-orders"
      />
    </Tooltip>
  )
}
